import network from '@/services/network';

/**
 * Admin-CRUD der Vermittler-Stammdaten (BER-67): Name, Vermittlernummer und
 * E-Mail gehören zusammen — die Nummer landet in der Beratungsdoku, die
 * E-Mail ist die inSign-Zuweisungsadresse der Firmen-Unterschriften
 * (Paten-Felder). Nur SA (softfair-defaults.manage).
 */
export interface VermittlerEintrag {
  id: number;
  name: string;
  nummer: string;
  email: string | null;
}

export interface VermittlerDaten {
  name: string;
  nummer: string;
  email: string | null;
}

const list = async (): Promise<VermittlerEintrag[]> => {
  const { data } = await network.get<{ data: VermittlerEintrag[] }>('/vermittler');
  return data.data;
};

const create = async (daten: VermittlerDaten): Promise<VermittlerEintrag> => {
  const { data } = await network.post<{ data: VermittlerEintrag }>('/vermittler', daten);
  return data.data;
};

const update = async (id: number, daten: VermittlerDaten): Promise<VermittlerEintrag> => {
  const { data } = await network.put<{ data: VermittlerEintrag }>(`/vermittler/${id}`, daten);
  return data.data;
};

const remove = async (id: number): Promise<void> => {
  await network.delete(`/vermittler/${id}`);
};

const vermittlerAdmin = { list, create, update, remove };

export default vermittlerAdmin;
